export const CLEAN_FORM = 'fuerzaventas/listarproductos/clean-form';
export const ADVANCED_SEARCH_CLOSE = 'main/advanced-search-close';
export const ADVANCED_SEARCH_OPEN = 'main/advanced-search-open';
export const SET_STATE_FORM = 'fuerzaventas/listarproductos/set-state-form';
export const UPDATE_FIELD_FILTER = 'fuerzaventas/listarproductos/update-field-filter';
export const RECEIVE_V_LIST = 'fuerzaventas/listarproductos/receive-v-list';
export const REQUEST_V_LIST = 'fuerzaventas/listarproductos/request-v-list';
export const ERROR_V_LIST = 'fuerzaventas/listarproductos/error-v-list';
export const SET_MASK = 'fuerzaventas/listarproductos/set-mask';
export const SET_ORDER = 'fuerzaventas/listarproductos/set-order';
export const RECEIVE_DATA= 'fuerzaventas/listarproductos/receibe-data';
export const UPDATE_TABLE_COLUMN= 'fuerzaventas/listarproductos/update-table-column';
export const SET_PAGE = 'fuerzaventas/listarproductos/set-page';
export const SET_SELECTED_ROW = 'fuerzaventas/listarproductos/set-selected-row';